<template>
  <v-sheet>
    <v-dialog
      v-model="isModalVisibleNetwork"
      max-width="500px"
    >
      <network-form />
    </v-dialog>

    <v-dialog
      v-model="confirmCancelNetwork"
      max-width="350"
    >
      <network-cancel />
    </v-dialog>

    <v-dialog
      v-model="promptDeleteNetwork"
      max-width="450"
    >
      <network-delete />
    </v-dialog>

    <v-dialog
      v-model="denyDeleteNetwork"
      max-width="350"
    >
      <network-deny />
    </v-dialog>
  </v-sheet>
</template>

<script>
import NetworkMixin from 'src/network/store/utils/networks-mixin'

export default {
  name: 'NetworkModals',
  components: {
    NetworkCancel: () => import('src/network/components/NetworkCancel'),
    NetworkDelete: () => import('src/network/components/NetworkDelete'),
    NetworkDeny: () => import('src/network/components/NetworkDeny'),
    NetworkForm: () => import('src/network/components/NetworkForm'),
  },
  mixins: [
    NetworkMixin,
  ],
}
</script>
